export const FETCH_SURVEY_SCORES_REQUEST = "FETCH_SURVEY_SCORES_REQUEST";
export const FETCH_SURVEY_SCORES_SUCCESS = "FETCH_SURVEY_SCORES_SUCCESS";
export const FETCH_SURVEY_SCORES_FAIL = "FETCH_SURVEY_SCORES_FAIL";
export const UPDATE_SURVEY_SCORE_REQUEST = "UPDATE_SURVEY_SCORE_REQUEST";
export const UPDATE_SURVEY_SCORE_SUCCESS = "UPDATE_SURVEY_SCORE_SUCCESS";
export const UPDATE_SURVEY_SCORE_FAIL = "UPDATE_SURVEY_SCORE_FAIL";
export const FETCH_SURVEY_SCORE_REQUEST = "FETCH_SURVEY_SCORE_REQUEST";
export const FETCH_SURVEY_SCORE_SUCCESS = "FETCH_SURVEY_SCORE_SUCCESS";
export const FETCH_SURVEY_SCORE_FAIL = "FETCH_SURVEY_SCORE_FAIL";
